import { useQuery } from "@tanstack/react-query";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { PolicyDetail } from "@/components/policies/policy-detail";
import { Link } from "@/core/lib/navigation";
import { policyQuery } from "@/lib/loaders";
import { Button } from "@/ui/components/ui/button";

/**
 * A single policy at `/policies/{id}` — content, files, version history, and
 * the acknowledgment report.
 *
 * The policy resolves in the loader so a bad id shows not-found before any
 * chrome renders; everything past that is client-side because the tabs each own
 * their own mutations and caches.
 */
export const Route = createFileRoute("/_workspace/policies/$id")({
  loader: async ({ context, params }) => {
    const policy = await context.queryClient.ensureQueryData(policyQuery(params.id));
    if (!policy) throw notFound();
    return policy;
  },
  component: PolicyPage,
});

function PolicyPage() {
  const { id } = Route.useParams();
  const { data: policy } = useQuery(policyQuery(id));
  if (!policy) return null;

  return (
    <main className="flex flex-1 flex-col p-4 md:p-6">
      <div className="mx-auto w-full max-w-4xl space-y-6">
        <Button asChild variant="ghost" size="sm" className="-ml-2 w-fit">
          <Link href="/policies">
            <ArrowLeftIcon className="size-4" />
            All policies
          </Link>
        </Button>
        <PolicyDetail initialPolicy={policy} />
      </div>
    </main>
  );
}
